import {
  setCallRead,
  setCallUnread,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { isValidAlertConversationID } from '@rsos/utils/talkJS';

/**
 * Util function to set a call as read.
 * In the emergencyCalls state:
 * - Sets the call's 'isUnread' status to false
 * - Removes the call object from the 'unreadCalls' array
 * @param {String} callerID - caller ID
 * @param {Function} dispatch - redux dispatch function
 */
export const handleReadCall = (callerID, dispatch) =>
  dispatch(setCallRead(callerID));

/**
 * Util function to set call(s) as unread.
 * In the emergencyCalls state:
 * - Sets the call's 'isUnread' status to false
 * - Adds the call object to the 'unreadCalls' array
 * @param {Object|null} session - TalkJS session
 * @param {Object} callQueue - emergency calls queue
 * @param {String|null} selectedCallerID - selected caller ID
 * @param {Function} dispatch - redux dispatch function
 */
export const handleUnreadCalls = (
  session,
  callQueue,
  selectedCallerID,
  dispatch,
) => {
  if (session?.unreads) {
    session.unreads.on('change', unreads => {
      const unreadCalls = [];

      // Loop through the TalkJS unreads array to filter the unread 911 call conversations then push
      // to the unreadCalls array.
      unreads.forEach(unread => {
        const conversationID = unread.lastMessage.conversation.id;

        if (!isValidAlertConversationID(conversationID)) {
          const callerID = unread.lastMessage.custom.selectedCallerID;

          const matchingConversationID =
            callQueue?.[callerID]?.agencyShareChat?.conversationID || null;

          if (
            callQueue?.[callerID] &&
            conversationID === matchingConversationID &&
            selectedCallerID !== callerID
          ) {
            unreadCalls.push(callQueue[callerID]);
          }
        }
      });

      dispatch(setCallUnread(unreadCalls));
    });
  }
};
